import { getNextScreenAboutYou } from "./Screens/AboutYou/AboutYou.route";
import { getNextScreenAboutYourDogsRoute } from "./Screens/AboutYourDogs/AboutYourDogs.route";
import { getNextScreenChoosingYourDog } from "./Screens/ChoosingYourDog/ChoosingYourDog.route";
import { getNextScreenRelationshipWithYourDog } from "./Screens/RelationshipWithYourDog/RelationshipWithYourDog.route";
import { getNextScreenSubsequentDog } from "./Screens/SubsequentDogs/SubsequentDogs.route";
import { getNextScreenThoughtsOnDogs } from "./Screens/ThoughtsOnDogs/ThoughtsOnDogs.route";
import { getNextScreenUnderstandingYourDog } from "./Screens/UnderstandingYourDog/UnderstandingYourDog.route";
import { getNextScreenWarmRoute } from "./Screens/Warm/Warm.route";

import { ABOUT_YOU } from "./Screens/AboutYou/AboutYou.debug";
import { ABOUT_YOUR_DOGS } from "./Screens/AboutYourDogs/AboutYourDogs.debug";
import { CHOOSING_YOUR_DOG } from "./Screens/ChoosingYourDog/ChoosingYourDog.debug";
import { GLOBAL } from "./Screens/Global/Global.debug";
import { RELATIONSHIP_WITH_YOUR_DOG } from "./Screens/RelationshipWithYourDog/RelationshipWithYourDog.debug";
import { SUBSEQUENT_DOG } from "./Screens/SubsequentDogs/SubsequentDogs.debug";
import { THOUGHTS_ON_DOGS } from "./Screens/ThoughtsOnDogs/ThoughtsOnDogs.debug";
import { UNDERSTANDING_YOUR_DOG } from "./Screens/UnderstandingYourDog/UnderstandingYourDog.debug";
import { WARM } from "./Screens/Warm/Warm.debug";

export const SCREEN_DEBUG_INFO: Partial<
	Record<NDS.RouteName, Partial<Record<NDS.ScreenName, string>>>
> = {
	ABOUT_YOU,
	ABOUT_YOUR_DOGS,
	CHOOSING_YOUR_DOG,
	RELATIONSHIP_WITH_YOUR_DOG,
	SUBSEQUENT_DOG,
	THOUGHTS_ON_DOGS,
	UNDERSTANDING_YOUR_DOG,
	WARM,
	GLOBAL,
};

/**
 * Given the current screen and form data, returns the next screen
 * @param currentScreen - The current screen
 * @param formData - The form data
 * @returns The next screen
 */
export const getNextScreen = (
	surveyState: NDS.SurveyState,
): ((
	surveyState: NDS.SurveyState,
	formData: NDS.FormData,
	questionSchema: NDS.QuestionSchema,
) => NDS.RouteChange) => {
	const routeMap = {
		WARM: getNextScreenWarmRoute,
		ABOUT_YOUR_DOGS: getNextScreenAboutYourDogsRoute,
		CHOOSING_YOUR_DOG: getNextScreenChoosingYourDog,
		UNDERSTANDING_YOUR_DOG: getNextScreenUnderstandingYourDog,
		RELATIONSHIP_WITH_YOUR_DOG: getNextScreenRelationshipWithYourDog,
		THOUGHTS_ON_DOGS: getNextScreenThoughtsOnDogs,
		ABOUT_YOU: getNextScreenAboutYou,
		SUBSEQUENT_DOG: getNextScreenSubsequentDog,
		GLOBAL: (
			surveyState: NDS.SurveyState,
			formData: NDS.FormData,
			_: NDS.QuestionSchema,
		) => ({
			surveyState,
			formData,
		}),
	};

	const currentScreenState =
		surveyState.routeStack[surveyState.routeStack.length - 1];

	return routeMap[currentScreenState.route];
};
